import React from "react";
import { Zap, ShieldCheck, Headphones, Lightbulb } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "../helpers";

const FEATURES = [
  { icon: Zap, title: "Fast Delivery", desc: "Agile execution and rapid iterations that get you to market faster without cutting corners." },
  { icon: ShieldCheck, title: "Secure & Scalable", desc: "Architecture built on best practices that grows effortlessly with your business." },
  { icon: Headphones, title: "Dedicated Support", desc: "A committed team that stays with you long after launch, 24/7." },
  { icon: Lightbulb, title: "Innovative Solutions", desc: "Cutting-edge AI and engineering to solve problems others can't." },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="relative py-28 md:py-32 bg-[#0B0B0E] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-brand-orange uppercase mb-4">/ Why Choose Us</p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            Built different, <span className="text-gradient-orange">by design</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <motion.div
                data-testid={`feature-card-${i}`}
                whileHover={{ y: -6 }}
                className="gradient-border group h-full rounded-3xl p-8 border border-white/5 hover:shadow-[0_0_40px_rgba(255,138,0,0.15)] transition-shadow duration-500"
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl glass border border-white/10">
                  <f.icon className="h-5 w-5 text-brand-orange group-hover:rotate-12 transition-transform duration-500" strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-heading font-medium text-xl tracking-tight">{f.title}</h3>
                <p className="mt-3 font-body text-sm text-brand-sec leading-relaxed">{f.desc}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
